import { combineReducers } from 'redux';

import authReducer from './authReducer';
import fileReducer from './fileReducer';
import folderReducer from './folderReducer';
import userReducer from './userReducer';
import youtubeDlReducer from './youtubeDlReducer';
import assetsReducer from './assetsReducer';

const reducer = combineReducers({
  authReducer,
  fileReducer,
  folderReducer,
  userReducer,
  youtubeDlReducer,
  assetsReducer,
});

const rootReducer = (state, action) => {
  return reducer(state, action);
};

export default rootReducer;
